import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getHigherRoles = async (role: string) => {
  const response = await queryExecute({
    variables: {
      miniumRole: role,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query higherRoles($miniumRole: String) {
        higherRoles(miniumRole: $miniumRole)
      }
    `),
  });

  return response.data.higherRoles;
};
